export default __webpack_public_path__ + "static/media/25081106.9f9a836a.png";